/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useEffect, useState} from 'react';
import PageBox from "../../layouts/pageBox";
import {Link, useNavigate, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import useAxiosJTW from "../../Hooks/useAxiosJTW";
import Loader from "../../elements/loader";

const MailActivation = () => {

    const axiosJWT = useAxiosJTW();
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    let params = useParams();

    const [success, setSuccess] = useState(0);

    const data = {
        title: ``,
        subtitle: ``
    };

    const userActivation = (data, signal) => {
        axiosJWT.post('api/activate', {uat : encodeURI(data)}, {signal}).then( (response) => {

            if(response.data.error == 3 || response.data.error == 4){
                setSuccess(2);
            }
            if(response.data.success){
                setSuccess(1);
            }


        } ).catch((error) => {
            console.log(error);
        });
    }

    useEffect( () =>{
        const controller = new AbortController();
        const signal= controller.signal;

        const queryParameters = new URLSearchParams(window.location.search);
        const _uat = queryParameters.get("uat");

        if(!_uat){
            navigate(`/${i18n.language}/`);
            return ;
        }else{
            userActivation(_uat, signal);
        }


        return () => {controller.abort();}
    }, [params] )


    return (
        <PageBox data={data} showAdds={false}>
            <div className='page-body'>
                <div className='pt-3'>
                    {success == 0 && <div style={{ paddingTop: '30px', textAlign : 'center', margin: '0 auto' }}><Loader/></div>}
                    {success == 1 && <>
                        <div className='loginDetails__title'>{t('login.AccountActivated')}</div>
                        <div className='loginDetails__text'>{t('login.Pleaselogin')}</div>
                        <div className='pt-3'>
                            <Link to={`/${i18n.language}/login`} className='btn btn-primary btn-login'>{t('footer.login')}</Link>
                        </div>
                    </>}
                    {success == 2 && <>
                        <div className="alert alert-danger" role="alert">
                            {t('login.somethingwrong')}
                        </div>
                    </>}
                </div>
            </div>
        </PageBox>
    );
};

export default MailActivation;